import { AIButtonOutlined as AIButtonOutlinedButton } from '../../AIButton'
import { BUTTON_ICON_SIZES, BUTTON_SIZES } from '../Buttons'
import { Container } from '../Container'

import EditIcon from '../../../icons/edit.svg'
import PlusIcon from '../../../icons/plus.svg'

export function AIButtonOutlined() {
  return (
    <>
      <Container label='AI Button, outlined, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton height={size} key={size} text='Button' />
        ))}
      </Container>
      <Container label='AI Button, outlined, disabled, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            disabled
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isLoading
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with pre icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with pre icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with post icon, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with post icon, with loader, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isLoading
            afterIconProps={{ Icon: EditIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, with skeleton, sizes - 48px, 40px, 32px, 24px, 20px'>
        {BUTTON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isSkeleton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, circle icon, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, circle icon, disabled, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            disabled
            isCircle
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, circle icon, with loader, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isCircle
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, outlined, circle icon, with skeleton, sizes - 48px, 40px, 32px, 24px'>
        {BUTTON_ICON_SIZES.map(size => (
          <AIButtonOutlinedButton
            isCircle
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
